import { z } from 'zod';

import { entityIdentifierSchema } from '../chat-entity';

export const richTextTextElementSchema = z.object({
    text: z.string(),
    type: z.literal('text'),
});

export type RichTextTextElement = z.infer<typeof richTextTextElementSchema>;

export const richTextMentionElementSchema = z.object({
    entity: entityIdentifierSchema,
    label: z.string().min(1),
    openInNewTab: z.boolean().optional(),
    type: z.literal('mention'),
});

export type RichTextMentionElement = z.infer<typeof richTextMentionElementSchema>;

export const richTextElementSchema = z.discriminatedUnion('type', [
    richTextTextElementSchema,
    richTextMentionElementSchema,
]);

export type RichTextElement = z.infer<typeof richTextElementSchema>;
